module.exports = __webpack_public_path__ + "img/lion_ashur.730596f3.jpg";